"use client";

import { FinancialAdmin } from "@/app/service/[id]/FinancialAdmin";
import { FirstResponder } from "@/app/service/[id]/FirstResponder";
import { BILLIN_SERVICE_ID } from "@/lib/billinConstants";

export function useBillinAdminView(serviceId?: string | null) {
  return serviceId === BILLIN_SERVICE_ID;
}

export default function ServiceDetailInline({
  serviceId,
  containerWidth,
}: {
  serviceId: string;
  containerWidth?: number;
}) {
  if (serviceId === BILLIN_SERVICE_ID) {
    return (
      <FinancialAdmin
        serviceId={serviceId}
        containerWidth={containerWidth}
      />
    );
  }

  return <FirstResponder serviceId={serviceId} />;
}
